export default {"src":"/_next/static/media/check-list.d047db51.svg","height":20,"width":20};